import { sendMethodEnum } from 'consts/data';
import { get, isArray, isString, uniq } from 'lodash';
import CampaignModel from './campaign.model';

class RouteModel {
  static isRouteNeedCreativeApprovalRequired(route) {
    return route?.details?.some((d) => d.setting.creativeApprovalRequired);
  }

  static isRouteMMS(messageTypes = '') {
    return (
      isString(messageTypes) &&
      messageTypes
        .split(',')
        .some((msgType) => CampaignModel.isMMS(msgType) || CampaignModel.isMMSE(msgType))
    );
  }

  static isRouteSMS(messageTypes) {
    return isString(messageTypes) && messageTypes.split(',').some(CampaignModel.isSMS);
  }

  static isRouteVoice(messageTypes) {
    return isString(messageTypes) && messageTypes.split(',').some(CampaignModel.isVoiceCampaign);
  }

  static getRoutes2Ways(routes) {
    if (isArray(routes)) {
      return routes.filter((route) =>
        (get(route, 'details', []) || []).some(
          (detailRoute) => detailRoute.sendMethod === sendMethodEnum.twoWays
        )
      );
    }

    return [];
  }

  static getRoutes1Way(routes) {
    if (isArray(routes)) {
      return routes.filter((route) =>
        (get(route, 'details', []) || []).some(
          (detailRoute) => detailRoute.sendMethod === sendMethodEnum.oneWay
        )
      );
    }

    return [];
  }

  static getOnlyRoutesActive(routes) {
    if (isArray(routes)) {
      return routes.filter((el) => el.status === 'ACTIVE');
    }

    return [];
  }

  static getCountriesSupportOneway(routes) {
    if (isArray(routes)) {
      const countries = [];
      routes.forEach((el) => {
        if (el?.details) {
          el?.details.forEach((d) => {
            if (d.sendMethod === sendMethodEnum.oneWay) {
              countries.push(d.country);
            }
          });
        }
      });

      return uniq(countries);
    }

    return [];
  }
}

export default RouteModel;
